import React from 'react';

import { styled } from '@mui/material/styles';
import { Edit } from 'react-admin';

const StyledEdit = styled(Edit)({
    maxWidth: 'none',
});

const MaxWidthEdit = (props) => {
    return (
        <StyledEdit
            {...props}
            mutationMode="pessimistic"
            redirect="edit"
        />
    );
};

export default MaxWidthEdit;
